export default  function getBenefits() {

    let url = `https://achimlanefesh.org.il/wp-json/achim/v1/benefits?per=15&paged=1`;
    let options = {
        method: 'GET',
        credentials: 'include',
    };
    return fetch(url, options)
        .then((response) => {
            return response.json();
        })
        .then((jsonObject) => {
            return jsonObject;
        });
}

